import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'issue-create.modal.existing-gic-warning.heading',
		defaultMessage: 'Draft issue in progress',
		description: 'Heading for the Existing GIC Warning modal',
	},
	description: {
		id: 'issue-create.modal.existing-gic-warning.description',
		defaultMessage:
			'It looks like you’re already creating an issue. Creating a new issue will discard your draft and any changes you’ve made won’t be saved.',
		description: 'Descriptive text for the Existing GIC Warning modal',
	},
	discardButton: {
		id: 'issue-create.modal.existing-gic-warning.discard-button',
		defaultMessage: 'Discard draft',
		description: 'Button that discards the current Global Issue Create modal and opens a new one',
	},
	keepEditingButton: {
		id: 'issue-create.modal.existing-gic-warning.keep-editing-button',
		defaultMessage: 'Keep editing',
		description:
			'Button that dismisses the Existing GIC Warning modal with no changes to the current Global Issue Create modal',
	},
	headingIssueTermRefresh: {
		id: 'issue-create.modal.existing-gic-warning.heading-issue-term-refresh',
		defaultMessage: 'Draft work item in progress',
		description: 'Heading for the Existing GIC Warning modal',
	},
	descriptionIssueTermRefresh: {
		id: 'issue-create.modal.existing-gic-warning.description-issue-term-refresh',
		defaultMessage:
			'It looks like you’re already creating a work item. Creating a new one will discard your draft and any changes you’ve made won’t be saved.',
		description: 'Descriptive text for the Existing GIC Warning modal',
	},
});
